export function NotFoundPage() {
  return (
    <div
      style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        textAlign: 'center',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 20px'
      }}
    >
      <div>
        <h1
          style={{
            display: 'inline-block',
            margin: '0 20px 0 0',
            paddingRight: '23px',
            fontSize: '24px',
            fontWeight: '500',
            verticalAlign: 'top',
            lineHeight: '49px',
            borderRight: '1px solid rgba(0, 0, 0, 0.3)'
          }}
        >
          404
        </h1>
        <div
          style={{
            display: 'inline-block',
            textAlign: 'left',
            lineHeight: '49px',
            height: '49px',
            verticalAlign: 'middle'
          }}
        >
          <h2 
            style={{
              fontSize: '14px', 
              fontWeight: 'normal',
              lineHeight: '49px',
              margin: 0,
              padding: 0
            }}
          >
            Không tìm thấy trang này
          </h2>
        </div>
      </div>
    </div>
  )
}
